module.exports = __webpack_public_path__ + "static/media/menuScale.d804aa4d.svg";